import React from "react";

import "./PracticeMode.css";

import {

    Zap,
    Activity,
    Brain,
    Eye,
    Sun,
    Search,
    Target,
    ArrowRight,
    Palette,
    BrainCircuit

} from "lucide-react";

import { useNavigate } from "react-router-dom";

const PracticeModes = () => {

    const navigate = useNavigate();

   const practiceModes = [

    {
        title: "Visual Acuity",
        description: "Sharpen your vision.",
        icon: <Eye size={30} />,
        color: "#F59E0B",
        route: "/visual-acuity"
    },

    {
        title: "Contrast Sensitivity",
        description: "Improve object detection.",
        icon: <Sun size={30} />,
        color: "#EF4444",
        route: "/contrast"
    },

    {
        title: "Color Vision",
        description: "Test color perception.",
        icon: <Palette size={30} />,
        color: "#8B5CF6",
        route: "/color-vision"
    },

    {
        title: "Reaction Speed",
        description: "Improve your response time.",
        icon: <Zap size={30} />,
        color: "#2563EB",
        route: "/reactiongame"
    },

    {
        title: "Complex Reaction",
        description: "Train decision making.",
        icon: <Activity size={30} />,
        color: "#7C3AED",
        route: "/complex-reaction"
    },

    {
        title: "Short Term Memory",
        description: "Improve visual recall.",
        icon: <BrainCircuit size={30} />,
        color: "#14B8A6",
        route: "/short-term-memory"
    },

    {
        title: "Working Memory",
        description: "Boost cognitive memory.",
        icon: <Brain size={30} />,
        color: "#10B981",
        route: "/working-memory"
    },

    {
        title: "Search Span",
        description: "Train visual scanning.",
        icon: <Search size={30} />,
        color: "#06B6D4",
        route: "/search-span"
    },

    {
        title: "Anticipation",
        description: "Predict movement faster.",
        icon: <Target size={30} />,
        color: "#EC4899",
        route: "/anticipation"
    }

];
    return (

        <div className="practice-section">

            <div className="practice-title">

                <h2>

                    Practice Modes

                </h2>

                <p>

                    Select a skill and start training.

                </p>

            </div>

            <div className="practice-grid">

                {

                    practiceModes.map((item,index)=>(

                        <div

                            key={index}

                            className="practice-mode-card"

                            onClick={()=>

                                navigate(item.route)

                            }

                        >

                            <div

                                className="practice-mode-icon"

                                style={{

                                    background:item.color

                                }}

                            >

                                {item.icon}

                            </div>

                            <h3>

                                {item.title}

                            </h3>

                            <p>

                                {item.description}

                            </p>

                            <div className="practice-footer">

                                <span>

                                    Start Training

                                </span>

                                <ArrowRight size={18}/>

                            </div>

                        </div>

                    ))

                }

            </div>

        </div>

    );

};

export default PracticeModes;